module.exports = __webpack_public_path__ + "static/media/gear-black.83717679.svg";